export function validateTargetingConfig(config, { maxDuration } = {}) {
  if (maxDuration && config.notVideoDuration > maxDuration) {
    return {
      valid: false,
      message: `La durée d'affichage ne peut pas dépasser ${maxDuration}s`,
    }
  }

  if (config.isDefault) {
    return { valid: true }
  }

  const hasGender = Boolean(config.gender)
  const hasAgeRange = Array.isArray(config.ageRange) && config.ageRange.length > 0

  if (!hasGender && !hasAgeRange) {
    return {
      valid: false,
      message:
        "Une ressource ciblée doit avoir au moins un critère (genre ou tranche d'âge)",
    }
  }

  return { valid: true }
}
